var filter_drawer_btns = $('.filter__drawer_trigger-button');
var overlay = $('.drawer-bg');

$(document).on('click', '.filter__drawer_trigger-button', function() {
    $('.collection__filter--drawer').toggleClass('shown');
    if($('.collection__filter--drawer').hasClass('shown')) {
      overlay.removeClass('hide');
    }else {
      overlay.addClass('hide');
    }
})
$(document).on('click', '.drawer-bg', function() {
    $('.collection__filter--drawer').toggleClass('shown');
    if($('.collection__filter--drawer').hasClass('shown')) {
      overlay.removeClass('hide');
    }else {
      overlay.addClass('hide');
    }
})
$(document).on('click', '#jsReadMore', function() {
    $('.js-truncated').addClass('expanded');
    console.log($("#descriptionFullContent").text())
    $(this).hide();
})
$(window).on('scroll', function() {
    const btn = $('#backToTop')
    const half_page = $('body').height() / 2
    const current_scroll = $(window).scrollTop()
    
    current_scroll >= half_page ? btn.addClass('show') : btn.removeClass('show');

})

$(document).on('click', '#backToTop', function() {
    $('html, body').animate({
        scrollTop: 0
    }, '300');
})


// Close filter drawer when click outside
// document.addEventListener('click', function(event) {
//     const drawer = document.querySelector('.collection__filter--drawer');
//     const isClickInside = drawer.contains(event.target)

//     if (drawer && isClickInside && drawer.classList.contains('shown')) {
//         drawer.classList.remove('shown');
//     }
// });
